//     This code was generated by a Reinforced.Typings tool. 
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { LicenseUsageDto } from '../../company/dto/LicenseUsageDto';
import { IApiRequest } from '../../IApiRequest';

export class GetCompanyLicenseUsageRequest extends IApiRequest<LicenseUsageDto>
{
	public $type = 'GetCompanyLicenseUsageRequest';
	constructor(public data: { companyId: string }) { super(); }
}
